import PercentageBar from "@public-client/Components/Charts/PercentageBar.vue";
export default {
  components: {
    PercentageBar
  },
  props: {
    domainIndicator: {
      type: Object,
      default() {
        return {};
      }
    },
    domain: {
      type: Object,
      default() {
        return {};
      }
    },
    fact: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      designation: {}
    };
  },
  computed: {
    percentage() {
      let percent = Math.round(this.fact.MeetsCount / this.fact.PossibleCount * 100);
      return Number.isNaN(percent) ? 0 : percent;
    }
  }
};